export const contact = {
  email: 'info@mayan-jo.com',
  phoneDisplay: '00962 (0) 222 72 52',
  phoneHref: 'tel:+9622227252',
  faxDisplay: '+962 6 554 0552',
  faxHref: 'tel:+96265540552',
  addressLines: [
    'Princess Zein bint Al-Hussein St.',
    'Next to Umm al-Summaq Municipality',
    'Umm al-Summaq Area, Building #88 — 2nd floor',
    'Amman, Jordan',
  ],
  addressShort: 'Umm al-Summaq, Building #88, 2nd floor, Amman, Jordan',
  mapEmbed:
    'https://www.google.com/maps?q=Princess+Zein+bint+Al-Hussein+St+Umm+al-Summaq+Amman+Jordan&output=embed',
};
